import {modals} from "@mantine/modals";
import ManageFavoriteLinksModal, {UserLinkEditable} from "@/components/SidebarLinks/ManageFavoriteLinksModal/modal.tsx";
import {ILinkCategoryWithLinks} from "@/types/models/ILinkCategory.ts";

export const MANAGE_FAVORITE_LINKS_MODAL_ID = "manageFavoriteLinksModal"

export default function openManageFavoriteLinksModal(linkData: ILinkCategoryWithLinks[], reloadLinks: () => void) {
    modals.open({
        modalId: MANAGE_FAVORITE_LINKS_MODAL_ID,
        title: "Manage Favorite Links",
        children: <ManageFavoriteLinksModal linkData={linkData} reloadLinks={reloadLinks}/>
    })
}

export function updateManageFavoriteLinksModal(linkData: ILinkCategoryWithLinks[], reloadLinks: () => void, favorites: UserLinkEditable[]) {
    modals.updateModal({
        modalId: MANAGE_FAVORITE_LINKS_MODAL_ID,
        title: "Manage Favorite Links",
        children: <ManageFavoriteLinksModal linkData={linkData} reloadLinks={reloadLinks} favorites={favorites}/>
    })
}